import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { ImagePath, ImagePathNode } from '../constants';
import { getImageUrl } from '../utils/getImageUrl';

const TestimonialCard = ({ item, bgColor }) => {
  const quoteStyle = {
    fontSize: "86px",
    fontWeight: "700",
    lineHeight: "60px",
    color: "red.main",
    display: "flex",

  };
  // const { testimonial_name, testimonial_rating, testimonial_description ,testimonial_image } = item
  const { name: testimonial_name, rating: testimonial_rating, review: testimonial_description, imageUrl: testimonial_image  } = item

  return (
    <Box sx={{ bgcolor: bgColor, borderRadius: "40px", p: { xs: "20px", lg: "41px 40px 50px" } }}>

      <Typography sx={{ ...quoteStyle, textAlign: "start" }}>“</Typography>
      <Typography variant="body1" textAlign="center" color='grey.500' dangerouslySetInnerHTML={{ __html: testimonial_description }}/>
       
      <Typography sx={{ ...quoteStyle, textAlign: "end", transform: "rotate(180deg)" }}>“</Typography>


      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2, mt: 3 }}>
        <Avatar src={getImageUrl(testimonial_image)} sx={{ width: "70px", height: "70px" }} />
        <Box>
          <Typography variant="h6">{testimonial_name}</Typography>
          <Box sx={{ display: "flex", gap: "2px" }}>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                sx={{
                  color: index < Math.round(Number(testimonial_rating)) ? "red.main" : "#EAEAEA",
                  fontSize: "25px"
                }}
              />
            ))}
          </Box>

        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialCard;
